import Box from "@mui/material/Box";
import React, { useEffect } from "react";
import { fadeIn } from "@ntg/component-library/utilities";
import { motion, AnimatePresence } from "motion/react";
import { TDomainType } from "../declarations/types";
import { SearchTextField } from "@ntg/components/text-fields";

interface ISearchToolbarProps {
    onSearch: (searchTerm: string) => void;
    domain: TDomainType;
}

export default function SearchToolbar(props: Readonly<ISearchToolbarProps>) {
    const [searchTerm, setSearchTerm] = React.useState<string>("");

    let label: string = "";
    switch (props.domain) {
        case "SalesOrder":
            label = "Search Sales Orders";
            break;
        case "ServiceOrder":
            label = "Search Service Orders";
            break;
        case "Manufacturing":
            label = "Search Manufacturing Orders";
            break;
        default:
            label = "Search";
    }

    useEffect(() => {
        return () => {
            setSearchTerm("");
        };
    }, [props.domain]);

    return (
        <Box
            sx={{
                alignItems: "center",
                display: "flex",
                justifyContent: "space-between",
                padding: 1,
            }}
        >
            <AnimatePresence>
                <motion.div {...fadeIn}>
                    <SearchTextField
                        Label={label}
                        SearchTerm={searchTerm}
                        OnSearchChange={(term) => {
                            setSearchTerm(term);
                            props.onSearch(term);
                        }}
                        OnSearch={() => {}}
                    />
                </motion.div>
            </AnimatePresence>
        </Box>
    );
}
